import React from 'react';

import { css } from '@emotion/react';
import { PageLayout } from '@gumtree/shared/src/types/srp';

import { breakpoints, gutterSizes, mediaQuery } from '../../base/theme';

export const ContentWrapper = ({
    children,
    pageLayout,
    ...props
}: React.PropsWithChildren<{
    pageLayout: PageLayout;
}>) => {
    const ContentWrapperStyles = css`
        padding: ${pageLayout === PageLayout.OneColumn ? '20px' : '16px'};
        overflow: hidden;

        ${pageLayout !== PageLayout.OneColumn && 'flex: auto;'};

        ${mediaQuery.from(breakpoints.medium)} {
            flex: auto;
        }

        ${mediaQuery.until(breakpoints.small)} {
            ${pageLayout === PageLayout.TwoColumns && `padding: ${gutterSizes.base}`};
        }
    `;

    return (
        <div css={ContentWrapperStyles} {...props}>
            {children}
        </div>
    );
};
